import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';

import { OfficialAccountAvatar } from '@/components/common';
import { isOfficalAddress } from '@/utils';
import { CommonDependency } from '@/dependency';

import style from './index.module.scss';
import cx from 'clsx';

export const UnionSearchUser = ({ data }: { data?: any }) => {
  const { t } = useTranslation();

  const UserCard = CommonDependency.components.UserCard;

  const isOfficialAccount = useMemo(() => isOfficalAddress(data?.id), [data]);

  return (
    <div className={cx(style.option)}>
      {isOfficialAccount ? (
        <div className={style.officialAccount}>
          <OfficialAccountAvatar
            logoVisible
            size={28}
            className={style.officialAccountAvatar}
            data={data}
            logoOption={{
              size: 18,
              customStyle: {
                right: '-3px',
                bottom: '-3px',
              },
            }}
          />
          <div>
            <div className={style.officialId}>{data.name}</div>
            <div className={style.officialAccountTag}>{t('MentionOption.ynzhfc')}</div>
          </div>
        </div>
      ) : (
        <UserCard isShowAmount disableMemo data={data?.desc}></UserCard>
      )}
    </div>
  );
};

export const MentionOption = ({ data }: { data?: any }) => {
  return (
    <div className={style.optionContainer}>
      <UnionSearchUser data={data} />
    </div>
  );
};
